import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import {
  DocumentTemplatesEffects,
  DocumentTemplatesFeature,
} from '@qtek/libs/store';

@NgModule({
  providers: [
    provideState(DocumentTemplatesFeature),
    provideEffects([DocumentTemplatesEffects]),
  ],
})
export class DocumentTemplatesModule {}
